/**
 * Return a valid public image URL, or the fallback.
 * Filters out placeholder/test URLs like https://img/a.jpg, empty strings, and non-http values.
 */
export function safeImg(url, fallback = "") {
  if (!url || typeof url !== "string") return fallback;
  const trimmed = url.trim();
  if (!trimmed) return fallback;
  // Must be an http(s) URL and the host must contain a dot (rules out "img/", "example.com" gets through, "img" doesn't)
  if (!/^https?:\/\/[^/]+\.[^/]+/i.test(trimmed)) return fallback;
  // Reject obvious placeholder domains
  const bad = ["example.com", "example.org", "placeholder.com"];
  try {
    const host = new URL(trimmed).hostname.toLowerCase();
    if (bad.some((b) => host === b || host.endsWith("." + b))) return fallback;
  } catch {
    return fallback;
  }
  return trimmed;
}
